import { createReducer, createActions } from "reduxsauce";

/**
 * ------------- Types and Action Creators -------------
 * The keys of the object will become keys of the Creators.
 * They will also become the keys of the Types after being
 * converted to SCREAMING_SNAKE_CASE.
 */
const { Types, Creators } = createActions({
  submitRequest: ["data"],
  estimateRequestFailure: null,
  estimateRequestSuccess: null,
});

export const EstimateRequestTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  // TODO: Refactor FreeEstimateForm to use redux instead of GenerateForm
  // selectedSoilIndex: null,
  // selectedIndexType: null,
  // selectedPrice: null,
  // user: {
  //   userType: null,
  //   firstName: null,
  //   lastName: null,
  //   email: null,
  //   phone: null,
  // },
  // isCashrenting: false,
  isCreatingEstimate: false,
};

/* ------------- Selectors ------------- */

export const EstimateSelectors = {};

/* ------------- Reducers ------------- */

export const submitRequest = (state = INITIAL_STATE) => ({
  ...state,
  isCreatingEstimate: true,
});

export const estimateRequestFailure = (state = INITIAL_STATE) => ({
    ...state,
    isCreatingEstimate: false,
  });

export const estimateRequestSuccess = () => INITIAL_STATE;

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SUBMIT_REQUEST]: submitRequest,
  [Types.ESTIMATE_REQUEST_FAILURE]: estimateRequestFailure,
  [Types.ESTIMATE_REQUEST_SUCCESS]: estimateRequestSuccess,
});
